<template>
	<div class="w-full">
		<vs-row>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" class="text-left">
				<vs-input
					v-model="questionsByPage[index].key"
					:description-text="$t('MODULE.map.subtitleKey')"
					class="w-full"
					:label="$t('MODULE.inputKey')"
					:placeholder="$t('MODULE.inputKey')"/>
			</vs-col>
		</vs-row>
		<vs-row>
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" class="text-left mt-4">
				<vs-input
					v-model="questionsByPage[index].content"
					@blur="validateUrl()"
					:description-text="$t('MODULE.map.subtitleView')"
					class="w-full"
					:label="$t('MODULE.map.labelView')"
					:placeholder="$t('MODULE.map.labelView')"/>
			</vs-col>
		</vs-row>
	</div>
</template>
<script type="text/javascript">
	import { mapState } from 'vuex';
	export default {
		props: ['index'],
		computed: {
			...mapState('resource',['questionsByPage']),
		},
		methods: {
            /**
             * Valida la estructura del link
             */
			validateUrl(){
					var pattern = new RegExp(/^(https|http)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi);
					const _url = this.questionsByPage[this.index].content;
					const test = pattern.test(_url);

					console.log('pattern.test(_url) ',test)

					if(test){
						const url = new URL(_url);
						if(!(url.protocol === "https:")){
							this.questionsByPage[this.index].content = '';
							this.$vs.notify({
					          title:'Danger',
					          text:'La url debe contener protocolo de seguridad https.',
					          color:'danger',
					      	  position:'top-right'});
						}

					}else {
						this.questionsByPage[this.index].content = '';
						this.$vs.notify({
			          	title:'Danger',
			          	text:'No es una url válida.',
			          	color:'danger',
			      	  	position:'top-right'});

					}
			}
		},
	}
</script>
